module.exports = __webpack_public_path__ + "img/content5_720_15.8459eb55.png";